import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexFlow: 'column',
    padding: '1rem 0',

    '&:not(:last-child)': {
      borderBottom: 'solid 1px lightgrey'
    }
  },

  row: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.35rem 0',
    height: 22
  },

  title: {
    fontStyle: 'normal',
    fontSize: theme.size.base,
    color: '#1F1F1F',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    cursor: 'pointer',
    marginBottom: '0.5rem'
  },

  label: {
    display: 'inline-flex',
    flexBasis: '90px',
    fontStyle: 'normal',
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  },

  data: {
    fontStyle: 'normal',
    fontSize: theme.size.sm,
    color: '#8F8F8F',
    display: 'flex',
    alignItems: 'center',
    cursor: 'default'
  },

  time: {
    opacity: '0.9',
    fontSize: theme.size.sm
  },

  assigneesRoot: {
    display: 'flex',
    alignItems: 'center'
  },

  avatar: {
    height: 22,
    width: 22
  },

  avatarBorder: {
    border: 'solid 2px white'
  },

  marginLeft: {
    zIndex: 1,
    marginLeft: '-8px'
  },

  menu: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: `1px solid ${theme.border.outline}`,
    borderRadius: '5px',
    boxSizing: 'border-box',
    padding: '0.118rem',
    cursor: 'not-allowed',
    backgroundColor: '#F5F6F8'
  },

  selectedStatus: {
    marginLeft: '0.5rem',
    marginRight: '0.5rem',
    fontSize: theme.size.sm,
    color: theme.palette.textAlt
  },

  dateRoot: {
    display: 'flex',
    alignItems: 'center',
    cursor: ({ canEdit }) => (canEdit ? 'pointer' : 'default'),

    '& label': {
      cursor: 'inherit'
    }
  },

  additionalAsignees: {
    marginLeft: 6,
    cursor: 'default'
  },

  asigneeDetailsIcon: {
    marginLeft: 6,
    cursor: 'pointer'
  },

  asigneeList: {
    padding: 12,
    border: '1px solid #F0F0F0',
    boxShadow: '0px 20px 30px 2px rgba(0, 0, 0, 0.16)',
    borderRadius: '5px',
    width: 180,
    backgroundColor: 'white'
  },

  asigneeListActions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 16
  },

  addAssigneeBtn: {
    color: '#8F8F8F',
    border: 'solid 1px #8F8F8F',
    backgroundColor: '#F0F0F0',
    borderRadius: '4px',
    padding: 6,
    cursor: 'pointer'
  },

  CloseAddAssigneeBtn: {
    color: '#8F8F8F',
    border: 0,
    cursor: 'pointer',
    backgroundColor: 'transparent'
  },

  unnassignedLabel: {
    color: '#8F8F8F'
  }
}))

export default useStyles
